import MainSwiper from "./MainSwiper";

export default MainSwiper;
